import { FC, HTMLAttributes } from 'react';

import useTooltipVoorraad from '../../hooks/useTooltipVoorraad';
import { AtomicKnoopMaterieel } from '../../state/types/VoorraadbeheerStore';
import { getClaimsTotaal } from '../../utils/voorraadbeheer';
import SidepanelToggle from '../Sidepanel/Toggle/SidepanelToggle';

import VoorraadDots from './VoorraadDots';

import styles from './VoorraadListItem.module.css';

type VoorraadRegionaalListItemProps = HTMLAttributes<HTMLDivElement> & {
  voorraadRegionaal: AtomicKnoopMaterieel;
};
const VoorraadRegionaalListItem: FC<VoorraadRegionaalListItemProps> = ({ voorraadRegionaal, ...divProps }) => {
  const { showTooltip, updateTooltip, hideTooltip } = useTooltipVoorraad();

  return (
    <SidepanelToggle voorraadRegionaal={voorraadRegionaal}>
      <div
        onMouseEnter={showTooltip(voorraadRegionaal.materieel, voorraadRegionaal)}
        onMouseMove={updateTooltip(voorraadRegionaal.materieel, voorraadRegionaal)}
        onMouseLeave={hideTooltip}
        className={[styles.row, divProps?.className ?? ''].join(' ')}
        {...divProps}
      >
        <div>{voorraadRegionaal.materieel}</div>
        <VoorraadDots
          aantal={voorraadRegionaal.overOfTekort}
          claimsCount={getClaimsTotaal(voorraadRegionaal.claims)}
          beschikbareReizigersdienst={
            voorraadRegionaal.aanwezig - voorraadRegionaal.inzetten - voorraadRegionaal.nietInzetbaar
          }
          nvt={voorraadRegionaal.nvt}
        />
      </div>
    </SidepanelToggle>
  );
};
export default VoorraadRegionaalListItem;
